module.exports = __webpack_public_path__ + "img/negrorojo.9850fbc9.jpg";